import { CSQuery } from './CSQuery';
import type { CSNamedEvent } from '../types/CSNamedEvent';
import type { CSQueryPayload } from '../types/CSQueryPayload';

interface CSCountQueryPayload extends CSQueryPayload {
    countField: string;
    namedEvent: CSNamedEvent;
}

class CSCountQuery extends CSQuery {
    private countField: string;
    private namedEvent: CSNamedEvent;

    constructor(countField: string, namedEvent: CSNamedEvent) {
        // Initialize with the specialized query type
        super('CSCountQuery');
        this.countField = countField;
        this.namedEvent = namedEvent;
    }

    setCountField(field: string): this {
        this.countField = field;
        return this;
    }

    setNamedEvent(event: CSNamedEvent): this {
        this.namedEvent = event;
        return this;
    }

    // Override build to include additional fields.
    build(): CSCountQueryPayload {
        return {
            ...super.build(),
            countField: this.countField,
            namedEvent: this.namedEvent,
        };
    }

    buildUrl(baseUrl: string): string {
        return `${baseUrl}/analytics/simplecount`;
    }
}

export type { CSCountQueryPayload };
export { CSCountQuery };
